import { images } from './';

const associados_content = { 
	razao_existir: [
		{
			title: "Visitas",
			text: "Foram 45 encontros de relacionamento em 2018.",
			image: images.associados_icon_1
		},
		{
			title: "Redes sociais",
			text: "Presença no LinkedIn, YouTube, Twitter, Facebook e Instagram.",
			image: images.associados_icon_2
		},
		{
			title: "WhatsApp",
			text: "Em agosto, foi iniciado o envio de conteúdos exclusivos sobre iniciativas, pautas e pleitos por esse canal.",
			image: images.associados_icon_3
		},
		{
			title: "Workplace",
			text: "Adoção do aplicativo corporativo do Facebook, que permite a criação de lives, enquetes e grupos de debate online.",
			image: images.associados_icon_4
		},
		{
			title: "E-mail da Central<br />do Associado",
			text: "Canal eletrônico para responder solicitações com agilidade e assertividade.",
			image: images.associados_icon_5
		}
	],
	associados_list: [{
		letter: "A",
		items: [
			"Aberdeen do Brasil Gestão de Recursos Ltda.",
			"Advalor DTVM Ltda.",
			"AGK Corretora de Câmbio S/A",
			"Ágora Corretora de Títulos e Valores Mobiliários S/A",
			"Alaska Investimentos Ltda.",
			"Albatross Corretora de Câmbio e Valores S/A",
			"Alianza Gestão de Recursos Ltda.",
			"AllianceBernstein Administradora de Carteiras (Brasil) Ltda.",
			"Angá Administração de Recursos Ltda.",
			"Angra Partners Gestão de Recursos Ltda.",
			"Apex Capital Ltda.",
			"Ápice Securitizadora S/A",
			"Argucia Capital Gestão de Recursos Ltda.",
			"Argumento Administração de Carteira de Títulos e Valores Mobiliários Ltda. – EPP",
			"Aria Capital Asset Administração de Recursos Ltda.",
			"ARX Investimentos Ltda.",
			"Ático Administração de Recursos Ltda.",
			"Ativa Investimentos S/A Corretora de Títulos, Câmbio e Valores",
			"AZ Quest Investimentos Ltda."
		]
	},{
		letter: "B",
		items: [
			"Bahia AM Renda Fixa Ltda.",
			"Banco A.J. Renner S/A",
			"Banco ABC Brasil S/A",
			"Banco Agiplan S/A",
			"Banco Alfa de Investimento S/A",
			"Banco Arbi S/A",
			"Banco B3 S/A",
			"Banco BI&P",
			"Banco BMG S/A",
			"Banco BNP Paribas Brasil S/A",
			"Banco Bocom BBM S/A",
			"Banco Bradesco BBI S/A",
			"Banco Bradesco Cartões S/A",
			"Banco Bradesco Financiamentos S/A",
			"Banco Bradesco S/A",
			"Banco BTG Pactual S/A",
			"Banco Caixa Geral – Brasil S/A",
			"Banco Cargill S/A",
			"Banco Citibank S/A",
			"Banco Clássico S/A",
			"Banco CNH Industrial Capital S/A",
			"Banco Cooperativo do Brasil S/A – BANCOOB",
			"Banco Cooperativo Sicredi S/A",
			"Banco Crédit Agricole Brasil S/A",
			"Banco da Amazônia S/A",
			"Banco Daycoval S/A",
			"Banco de Investimentos Credit Suisse (Brasil) S/A",
			"Banco de la Nación Argentina",
			"Banco de la Provincia de Buenos Aires",
			"Banco de la República Oriental del Uruguay",
			"Banco do Brasil S/A",
			"Banco do Estado de Sergipe S/A",
			"Banco do Estado do Pará S/A",
			"Banco do Estado do Rio Grande do Sul S/A",
			"Banco do Nordeste do Brasil S/A",
			"Banco Fator S/A",
			"Banco Fidis S/A",
			"Banco GMAC S/A",
			"Banco Guanabara S/A",
			"Banco Honda S/A",
			"Banco Induscred de Investimentos S/A",
			"Banco Industrial do Brasil S/A",
			"Banco Itaú BBA S/A",
			"Banco J.P. Morgan S/A",
			"Banco John Deere S/A",
			"Banco Luso Brasileiro S/A",
			"Banco Máxima S/A",
			"Banco Maxinvest S/A",
			"Banco Mercantil do Brasil S/A",
			"Banco Mizuho do Brasil S/A",
			"Banco Modal S/A",
			"Banco Morgan Stanley S/A",
			"Banco MUFG Brasil S/A",
			"Banco Original do Agronegócio S/A",
			"Banco Ourinvest S/A",
			"Banco Paulista S/A",
			"Banco Pine S/A",
			"Banco PSA Finance Brasil S/A",
			"Banco Rabobank International Brasil S/A",
			"Banco Rendimento S/A",
			"Banco Ribeirão Preto S/A",
			"Banco Safra S/A",
			"Banco Santander (Brasil) S/A",
			"Banco Semear S/A",
			"Banco Société Générale Brasil S/A",
			"Banco Triângulo S/A",
			"Banco Votorantim S/A",
			"Banestes S/A - Banco do Estado do Espírito Santo",
			"Banif - Banco Internacional do Funchal (Brasil) S/A",
			"Bank of America Merrill Lynch Banco Múltiplo S/A",
			"BB Banco de Investimento S/A",
			"BB Gestão de Recursos DTVM S/A",
			"BC Gestão de Recursos Ltda.",
			"Berkana Investimentos e Gestão de Recursos Ltda.",
			"BGC Liquidez DTVM Ltda.",
			"BlackRock Brasil Gestora de Investimentos Ltda.",
			"BNY Mellon Serviços Financeiros DTVM S/A",
			"Bozano Investimentos Ltda.",
			"Brainvest Consultoria Financeira Ltda.",
			"Bram - Bradesco Asset Management S/A DTVM",
			"Brasil Plural S.A. - Banco Múltiplo",
			"BRB – DTVM S/A",
			"Brei - Brazilian Real Estate Investments Ltda.",
			"Bresser Administração de Recursos Ltda.",
			"BRL Trust DTVM S/A",
			"Brookfield Brasil Asset Management Investimentos Ltda.",
			"BRZ Investimentos Ltda.",
			"BW Gestão de Investimentos Ltda."
		]
	}, {
		letter: "C",
		items: [
			"CA Indosuez Wealth (Brazil) S/A DTVM",
			"Caixa Econômica Federal",
			"Canvas Investimentos Ltda.",
			"Capitânia S/A",
			"Captalys Gestão Ltda.",
			"China Construction Bank (Brasil) Banco Múltiplo S/A",
			"Cibrasec Administradora de Recursos Ltda.",
			"Claritas Administração de Recursos Ltda.",
			"CM Capital Markets Corretora de Câmbio, Títulos e Valores Mobiliários Ltda.",
			"Codepe Corretora de Valores S/A",
			"Coinvalores Corretora de Câmbio e Valores Mobiliários Ltda.",
			"Coluna S/A DTVM",
			"Concórdia S/A - C.V.M.C. e Commodities",
			"Consenso Participações Ltda.",
			"CP & Frizzo - DTVM Ltda.",
		]
	}, {
		letter: "D",
		items: [
			"Deutsche Bank S/A - Banco Alemão",
			"Dynamo Administração de Recursos Ltda."
		]
	}, {
		letter: "E",
		items: [
			"Elite Corretora de Câmbio e Valores Mobiliários Ltda.",
			"Elta Participações S/A",
			"Endurance Capital Partners Ltda.",
			"Equitas Administração de Fundos de Investimentos Ltda.",
			"Euroinvest S/A Corretora de Câmbio, Títulos e Valores Mobiliários",
			"Explora Investimentos Gestão de Recursos Ltda."
		]
	}, {
		letter: "F",
		items: [
			"Fair Corretora de Câmbio S/A",
			"Fator S/A - Corretora de Valores",
			"Fides Asset Management Ltda.",
			"Finaxis Corretora de Títulos e Valores Mobiliários S/A",
			"Foco DTVM Ltda.",
			"Fram Capital Gestão de Ativos Ltda.",
			"Franklin Templeton Investimentos (Brasil) Ltda."
		]
	}, {
		letter: "G",
		items: [  
			"G5 Administradora de Recursos Ltda.",
			"Gaia Securitizadora S/A",
			"Garde Asset Management Gestão de Recursos Ltda.",
			"Gávea Investimentos Ltda.",
			"Genial Investimentos Corretora de Valores Mobiliários S/A",
			"Gerval Investimentos Ltda.",
			"Goldman Sachs do Brasil Banco Múltiplo S/A",
			"GPS Planejamento Financeiro Ltda.",
			"Guepardo Investimentos Ltda.",
			"Guide Investimentos S/A Corretora de Valores",
			"GWI Asset Management S/A"
		]
	}, {
		letter: "H",
		items: [
			"H. Commcor DTVM Ltda.",
			"Haitong Banco de Investimento do Brasil S/A",
			"Hedge Alternative Investments Ltda.",
			"Highland Capital Brasil Gestora de Recursos Ltda.",
			"HSBC Brasil S/A - Banco de Investimento"
		]
	}, {
		letter: "I",
		items: [
			"Ibirapuera Performance Investimentos Ltda.",
			"ICAP do Brasil Corretora de Títulos e Valores Mobiliários Ltda.",
			"Icatu DTVM Ltda.",
			"Icatu Gestão Patrimonial Ltda.",
			"Icatu Vanguarda Gestão de Recursos Ltda.",
			"Icla Trust DTVM S/A",
			"Infinity Corretora de Câmbio, Títulos e Valores Mobiliários S/A",
			"Infra Asset Management Ltda.",
			"ING Corretora de Câmbio e Títulos S/A",
			"Integral Investimentos Ltda.",
			"Integral Trust Gestora de Recursos Ltda.",
			"INTL FCStone DTVM Ltda.",
			"Investidor Profissional Gestão de Recursos Ltda.",
			"Itaú Unibanco S/A",
			"Itaverá Gestão de Recursos Ltda."
		]
	}, {
		letter: "J",
		items: [
			"Jardim Botânico Partners Investimentos Ltda.",
			"JGP Gestão de Crédito Ltda."
		]
	}, {
		letter: "K",
		items: [
			"Kinea Investimentos Ltda.",
			"Kobold Gestora de Fundos Ltda.",
			"Kondor Administradora e Gestora de Recursos Financeiros Ltda."
		]
	}, {
		letter: "L",
		items: [
			"Lacan Investimentos e Participações Ltda.",
			"Lanx Capital Investimentos Ltda.",
			"Lavoro Asset Management S/A",
			"Leblon Equities Gestão de Recursos Ltda.",
			"Lecca DTVM Ltda.",
			"LLA DTVM Ltda."
		]
	}, {
		letter: "M",
		items: [
			"M Square Investimentos Ltda.",
			"Magliano S/A Corretora de Câmbio e Valores Mobiliários",
			"Mauá Investimentos Ltda.",
			"Meta Asset Management Ltda.",
			"MHFT Investimentos S/A",
			"Mirae Asset Global Investments (Brasil) Gestão de Recursos Ltda.",
			"Monte Equity Partners Gestão de Recursos Ltda.",
			"Murano Investimentos Gestão de Recursos Ltda."
		]
	}, {
		letter: "N",
		items: [
			"Neo Gestão de Recursos Ltda.",
			"Novação Administração e Participação Ltda.",
			"Novero Investimentos Ltda."
		]
	}, {
		letter: "O",
		items: [
			"O3 Gestão de Recursos Ltda.",
			"Oceana Investimentos Administração de Carteira de Valores Mobiliários Ltda.",
			"Oliveira Trust DTVM S/A",
			"Opportunity Asset Administração de Recursos de Terceiros Ltda.",
			"Órama DTVM S/A",
			"Orla DTVM S/A",
			"Ouro Preto Gestão de Recursos S/A"
		]
	}, {
		letter: "P",
		items: [
			"Pacífico Gestão de Recursos Ltda.",
			"Paineiras Investimentos",
			"Pátria Investimentos Ltda.",
			"Pentágono S/A DTVM",
			"Perfin Administração de Recursos Ltda.",
			"Pimco Latin America Administradora de Carteiras Ltda.",
			"Planner Corretora de Valores S/A",
			"Polo Capital Gestão de Recursos Ltda.",
			"Portocred S/A, Crédito, Financiamento e Investimento",
			"Portopar DTVM Ltda.",
			"Positiva Corretora de Títulos e Valores Mobiliários S/A",
			"Pragma Gestão de Patrimônio Ltda.",
			"Prime S/A Corretora de Câmbio e Valores"
		]
	}, {
		letter: "Q",
		items: [
			"Quantitas Gestão de Recursos S/A"
		]
	}, {
		letter: "R",
		items: [
			"RB Capital Asset Management Ltda.",
			"RB Capital DTVM Ltda.",
			"Reag Gestora de Recursos Ltda.",
			"RedAsset Gestão de Recursos Ltda.",
			"Reliance Asset Management Administração de Recursos Ltda.",
			"Reliance DTVM Ltda.",
			"Renascença DTVM Ltda.",
			"Rio Bravo Investimentos DTVM Ltda.",
			"RJI Corretora de Títulos e Valores Mobiliários Ltda."
		]
	}, {
		letter: "S",
		items: [
			"Saga Gestão de Investimentos Financeiros Ltda.",
			"Santander Brasil Gestão de Recursos Ltda.",
			"Santander Securities Services Brasil DTVM",
			"São João Gestora de Recursos Ltda.",
			"Schroder Investment Management Brasil Ltda.",
			"Set Investimentos Gestão de Ativos Ltda.",
			"Simplific Pavarini DTVM Ltda.",
			"SLW Corretora de Valores e Câmbio Ltda.",
			"Socopa - Sociedade Corretora Paulista S/A",
			"Somma Investimentos S/A",
			"Sparta Administradora de Recursos Ltda.",
			"Spinelli S/A Corretora de Valores Mobiliários e Câmbio",
			"SPX Gestão de Recursos Ltda.",
			"Squadra Investimentos - Gestão de Recursos Ltda.",
			"Standard Chartered Bank (Brasil) S/A - Banco de Investimento",
			"Stepstone Gestão de Recursos Ltda.",
			"STK Capital Gestora de Recursos Ltda.",
			"Sul América Investimentos DTVM S/A"
		]
	}, {
		letter: "T",
		items: [
			"TAG Investimentos Ltda.",
			"Taler Planejamentos Financeiros Ltda.",
			"Tarpon Gestora de Recursos S/A",
			"Tendência Corretora de Câmbio, Títulos e Valores Mobiliários Ltda.",
			"Tullett Prebon Brasil S/A Corretora de Valores e Câmbio",
			"Turim 21 Investimentos Ltda."
		]
	}, {
		letter: "U",
		items: [
			"UBS Brasil Administradora de Valores Mobiliários Ltda.",
			"UBS Brasil Corretora de Câmbio, Títulos e Valores Mobiliários S/A",
			"UM Investimentos S/A Corretora de Títulos e Valores Mobiliários"
		]
	}, {
		letter: "V",
		items: [
			"Velt Partners Investimentos Ltda.",
			"Ventor Investimentos Ltda.",
			"Verde Asset Management S/A",
			"Vert Companhia Securitizadora",
			"Victoire Brasil Investimentos Administração de Recursos Ltda.",
			"Vinci Gestora de Recursos Ltda.",
			"Vintage Investimentos Ltda.",
			"Vision Brazil Gestão de Investimentos e Participações Ltda.",
			"Vórtx DTVM Ltda.",
			"Votorantim Asset Management DTVM Ltda."
		]
	}, {
		letter: "W",
		items: [
			"Western Asset Management Company DTVM Ltda.",
			"Wright Capital Gestão De Recursos Ltda. ME"
		]
	}, {
		letter: "X",
		items: [
			"XP Investimentos Corretora de Câmbio, Títulos e Valores Mobiliários S/A"
		]
	}]
};

export { associados_content };